import HttpBackend from 'i18next-http-backend';
export default (function (i18n, plugins) {
    var hasCustomBackend = plugins === null || plugins === void 0 ? void 0 : plugins.some(function (plugin) {
        return Array.isArray(plugin)
            ? plugin.some(function (p) { return p.type === 'backend'; })
            : plugin.type === 'backend';
    });
    if (!hasCustomBackend) {
        i18n.use(HttpBackend);
    }
    return i18n;
});
